import { types } from 'mobx-state-tree';

const BaseSkeleton = types.model('Skeleton', {
  height: types.number,
});

export default BaseSkeleton;
